// Yup
import { object, string } from 'yup';

import { addressSchema } from './addressSchema';

function isValidCNPJ(cnpj: string): boolean {
  const stripped = cnpj.replace(/[^\d]/g, '');

  if (stripped.length !== 14) return false;
  if (/^(\d)\1+$/.test(stripped)) return false;

  const calcDigit = (base: string, weights: number[]) => {
    const sum = base
      .split('')
      .reduce((acc, num, i) => acc + parseInt(num) * weights[i], 0);
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const digit1 = calcDigit(stripped.slice(0, 12), weights1);
  const digit2 = calcDigit(stripped.slice(0, 13), weights2);

  return (
    digit1 === parseInt(stripped[12]) &&
    digit2 === parseInt(stripped[13])
  );
}

const companySchema = object().shape({
  name: string().required('Campo nome obrigatório'),
  cnpj: string()
    .required('Campo CNPJ obrigatório')
    .test('cnpj-valido', 'Digite um CNPJ válido', (value) =>
      isValidCNPJ(value ?? ''),
    ),
  phone: string().matches(/\(\d{2,}\) \d{4,}\-\d{4}/g, {
    message: 'Digite um número válido',
  }),
  email: string().email('Por favor digite um e-mail válido'),
  address: addressSchema,
});

export default companySchema;
export { companySchema };
